import { Switch, Table } from 'antd';
import { MdEdit } from "react-icons/md";
import React, { useEffect, useState } from 'react';
import { MarkupMainContainer } from '../../../StyledComponents/Markup';
import { ButtonHeadSection, ContentContainer, TableTitle, TableTop } from '../../../StyledComponents/CreateKeyAccountManager';
import AddButton from '../Common/AddButton';
import { SpinContainer } from '../../../StyledComponents/Queries';
import { Spin } from 'antd';

import ContentHead from '../Common/ContentHead';

import CreateODCSStrategyForm from './CreateODCSStrategyForm';
import { useDispatch, useSelector } from 'react-redux';
import { deleteODCSMarkup, getOdccStrategiesList } from "../../../store/Markup/markupSlice";
import { mapMarkupDataToOdcsData } from './utilitiesFunction';
import { updatenotificationdata } from '../../../store/Common/CommonSlice';
import SearchBox from '../Common/SearchBox';
let debounceTimer = null;
export const ODCCStrategies = () => {
  const [pageType, setPageType] = useState("table");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOdccStrategiesList('')).then(res => setData(mapMarkupDataToOdcsData(res.payload)));
  }, [pageType]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (current, size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handleEditClick = (record) => {
    setSelectedRecord(record);
    setPageType("edit");
  };
  const handleDelete = (record) => {
    const object = {
      odcc_id: record.id,
      isActive: !record.isActive
    }
    dispatch(deleteODCSMarkup(object)).then((res) => {
      console.log(res,"******************")
      dispatch(updatenotificationdata(res.payload))
      dispatch(getOdccStrategiesList('')).then(res => setData(mapMarkupDataToOdcsData(res.payload)));
      setPageType("table")
    }).catch((error) => {
      
      dispatch(updatenotificationdata(error.payload.response.data))
    })

    // dispatch(getOdccStrategiesList()).then(res => setData(mapMarkupDataToOdcsData(res.payload)));
  };

  const columns = [
    { title: 'ORIGIN', dataIndex: 'origin', width: "50px" },
    { title: 'DESTINATION', dataIndex: 'destination' },
    { title: 'CARRIER', dataIndex: 'carrier' },
    { title: 'COMMODITY', dataIndex: 'commodity' },
    { title: 'CUSTOMER CATEGORY', dataIndex: 'customer_category', width: "50px" },
    { title: 'MARKUP %', dataIndex: 'markup' },
    { title: 'ACTIVE FROM', dataIndex: 'active_from' },
    { title: 'ACTIVE TILL', dataIndex: 'active_till' },
    {
      title: 'ACTION',
      dataIndex: 'action',
      align: "right",
      render: (text, record) => (

        <div className="flex items-center gap-2 ">
          <button className="text-2xl pointer-cursor text-black hover:text-green-600" onClick={() => handleEditClick(record)}><MdEdit /></button>
          <Switch
            checked={record.isActive}
            onChange={() => handleDelete(record)}
            style={{
              backgroundColor: record.isActive ? '#00C851' : '#ff4444',
            }}
          />
        </div>
      ),
    },
  ];

    const onSearch = (value) => {
      let queryStringObj = {};
      if (value?.length > 0) {
        queryStringObj["search"] = value;
      }
      let queryString = new URLSearchParams(queryStringObj).toString();
      queryString = queryString ? `?${queryString}` : "";
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        dispatch(getOdccStrategiesList(queryString)).then(res => setData(mapMarkupDataToOdcsData(res.payload)));
      }, 700);
    };

  return (
    <MarkupMainContainer>
      {pageType === 'table' ? (
        <>
          <ContentContainer>
            <TableTop>
              <TableTitle>ODCC Strategies</TableTitle>
              <div className='filter_wrap'>
              <ButtonHeadSection>
              <SearchBox
                  onSearch={onSearch}
                />
                <AddButton title="ODCC Strategy" handleClick={() => setPageType("create")} />
              </ButtonHeadSection>
              </div>
            </TableTop>
            {loading ? (
              <SpinContainer className='user-quote'>
                <Spin />
              </SpinContainer>
            ) : (
              // <SimpleTableScroll className="markup-odcs-list" currentPage={currentPage} pageSize={pageSize} columns={columns} data={data} scroll={true} showScroll={true} fpadding="1px 0px" />

              <Table
                style={{ marginTop: "8px", color: "#B5B5C3", backgroundColor: "#fff" }}
                columns={columns}
                dataSource={data}
                bordered
                pagination={{
                  position: ["bottomCenter"],
                  className: "centered-pagination",
                }}
                scroll={{ x: "max-content" }}
              />
            )}
          </ContentContainer>
          {/* {data?.length && (
            <TablePagination
              style={{ marginTop: 16, textAlign: 'center' }}
              onChange={handlePageChange}
              onShowSizeChange={handlePageSizeChange}
              defaultCurrent={currentPage}
              defaultPageSize={10}
              total={data?.length ? data.length : 10}
              showSizeChanger={false}
              showQuickJumper={false}
            />
          )} */}
        </>
      ) : (
        <ContentContainer>
          <ContentHead title="Strategy Details" handleClick={() => setPageType("table")} />
          <CreateODCSStrategyForm setPageType={setPageType} pageType={pageType} existedOdcs={selectedRecord} />
        </ContentContainer>
      )}
    </MarkupMainContainer>
  );
};